/**
 * @description 登录注册
 */
import LOGIN from '@/api/module/login';

const USERLOGIN = {
  namespaced: true,
  state: {
    industryOptions: [], // 行业信息字典
    addressOptions: [], // 国标地址信息字典
  },
  mutations: {
    setIndustryOptions(state, data = []) {
      state.industryOptions = [...data];
    },
    setAddressOptions(state, data = []) {
      state.addressOptions = [...data];
    },
  },
  actions: {
    // 获取图片验证码
    // eslint-disable-next-line
    async getImageVerifyCode({ commit }, params = {}) {
      try {
        const res = await LOGIN.getImageVerifyCode(params);
        return Promise.resolve(res);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    // 获取邮箱验证码
    // eslint-disable-next-line
    async getEmailVerifyCode({ commit }, params = {}) {
      try {
        const authKey = await LOGIN.getEmailVerifyCode(params);
        console.log('authKey: ', authKey);
        localStorage.setItem('EMAIL_AK', authKey);
        return Promise.resolve(authKey);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    // 邮箱验证码校验
    // eslint-disable-next-line
    async checkEmailVerifyCode({ commit }, params = {}) {
      try {
        const result = await LOGIN.checkEmailVerifyCode(params);
        return Promise.resolve(result);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    // 获取行业信息字典
    async getIndustryOptions({ commit }, params = {}) {
      try {
        const result = await LOGIN.getIndustryList(params);
        commit('setIndustryOptions', result);
        return Promise.resolve(result);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    // 获取国标省份信息字典
    async getAddressOptions({ commit }, params = {}) {
      try {
        const result = await LOGIN.getAddressList(params);
        commit('setAddressOptions', result);
        return Promise.resolve(result);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    // 获取手机验证码
    // eslint-disable-next-line
    async getPhoneVerifyCode({ commit }, params = {}) {
      try {
        const authKey = await LOGIN.getPhoneVerifyCode(params);
        localStorage.setItem('PHONE_AK', authKey);
        return Promise.resolve(authKey);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    // 手机验证码校验
    // eslint-disable-next-line
    async checkPhoneVerifyCode({ commit }, params = {}) {
      try {
        const result = await LOGIN.checkPhoneVerifyCode(params);
        return Promise.resolve(result);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    // 图片验证码校验
    // eslint-disable-next-line
    async checkImageVerifyCode({ commit }, params = {}) {
      try {
        const result = await LOGIN.checkImageVerifyCode(params);
        return Promise.resolve(result);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    // 用户注册
    // eslint-disable-next-line
    async submitUserRegister({ commit }, params = {}) {
      try {
        const registerRes = await LOGIN.userRegister(params);
        console.log('注册 ==> registerRes', registerRes);
        return Promise.resolve(registerRes);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    // 用户登录登录
    // eslint-disable-next-line
    async handleUserLogin({ commit }, params = {}) {
      try {
        const result = await LOGIN.userLogin(params);
        console.log('登录result: ', result);
        if (result.userInfo) {
          localStorage.setItem('loginUesr', JSON.stringify(result));
        }
        return Promise.resolve(result);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    // 校验账号是否已注册
    // eslint-disable-next-line
    async checkAccountRegistered({ commit }, params = {}) {
      try {
        const result = await LOGIN.checkAccountRegistered(params);
        console.log('校验账号是否已注册: ', result);
        return Promise.resolve(result);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    // 重置密码
    // eslint-disable-next-line
    async handleResetPwd({ commit }, params = {}) {
      try {
        const result = await LOGIN.userUpdatePwd(params);
        console.log('重置密码res: ', result);
        return Promise.resolve(result);
      } catch (err) {
        return Promise.reject(err);
      }
    },
  },
  getters: {
    industryOptions: state => {
      let newArr = [];
      state.industryOptions.forEach(firIndustry => {
        const obj = {
          label: firIndustry.dicName,
          value: firIndustry.dicCode,
          children: firIndustry.childrenRes || [],
        };
        newArr.push(obj);
      });
      return newArr;
    },
    provinceOptions: state => {
      let newArr = [];
      state.addressOptions.forEach(provinceItem => {
        const obj = {
          label: provinceItem.dicName,
          value: provinceItem.dicCode,
          children: provinceItem.childrenRes || [],
        };
        newArr.push(obj);
      });
      return newArr;
    },
  },
};

export default USERLOGIN;
